module.exports = __webpack_public_path__ + "static/media/  (73).10827c72.jpg";